// Ids match what the M5 reseed migration (20260727160000_reseed_purchase_order_statuses)
// actually produces: DELETE + re-INSERT with no explicit ids, continuing the existing
// autoincrement sequence past the 7 rows from the original seed_enumerations migration.
// That migration is already applied in deployed environments and cannot be changed, so
// these numbers must match its real output, not a fresh 1-6 numbering.
export var PurchaseOrderStatus;
(function (PurchaseOrderStatus) {
    PurchaseOrderStatus[PurchaseOrderStatus["DRAFT"] = 8] = "DRAFT";
    PurchaseOrderStatus[PurchaseOrderStatus["ISSUED"] = 9] = "ISSUED";
    PurchaseOrderStatus[PurchaseOrderStatus["SHIPPED"] = 10] = "SHIPPED";
    PurchaseOrderStatus[PurchaseOrderStatus["PARTIALLY_RECEIVED"] = 11] = "PARTIALLY_RECEIVED";
    PurchaseOrderStatus[PurchaseOrderStatus["RECEIVED"] = 12] = "RECEIVED";
    PurchaseOrderStatus[PurchaseOrderStatus["CANCELLED"] = 13] = "CANCELLED";
})(PurchaseOrderStatus || (PurchaseOrderStatus = {}));
/** Seeded display names — compare to `status.name` in UI/lifecycle only, not for DB lookups. */
export const purchaseOrderStatusName = {
    DRAFT: 'Draft',
    ISSUED: 'Issued',
    SHIPPED: 'Shipped',
    PARTIALLY_RECEIVED: 'Partially Received',
    RECEIVED: 'Received',
    CANCELLED: 'Cancelled',
};
//# sourceMappingURL=purchase-order-status.js.map